module.exports = __webpack_public_path__ + "static/media/empty-cart.dd38f7e6.png";